import VeeValidate from "vee-validate";
// @ts-ignore
import VueValidationEn from "vee-validate/dist/locale/en";
import Vue from "vue";

Vue.use(VeeValidate, {
  inject: false,
  locale: "en",
  dictionary: {
    en: VueValidationEn
  }
});
